// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import DemoBoot from "./demo/DemoBoot";
import "./index.css";

// DemoBoot owns the whole entry flow: sign-in, sandbox creation, then the
// portal itself (imported lazily, so it never loads for signed-out visitors).
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <DemoBoot />
  </React.StrictMode>
);
